<section class="part">
  @if (strapiContent$ | async; as strapiContent) {
  <div [innerHTML]="strapiContent">
    <h5 class="heading">Companies you may access</h5>
    <p class="instructions">Search below and or select a company to see its data.</p>
  </div>
  } @else {

  <h5 class="heading">Companies you may access</h5>
  <p class="instructions">Search below and or select a company to see its data.</p>

  }

  <input type="text" id="type-ahead__val" class="type-ahead__val" placeholder="Company Name…" [formControl]="filter" />
</section>
<section class="part">
  <ul class="list-unstyled">
    @for (account of accounts$ | async; track account; let i = $index) {
    <ng-container #accountList>
      <li class="account-list-item">
        <a
          href="javascript:void(0)"
          class="account-item ph-no-capture"
          [class]="account.AccountId === acctId && !isClicked ? 'highlighted' : ''"
          (click)="switchAccount(account.AccountId, i)"
        >
          <ngb-highlight [result]="account.AccountName" [term]="filter.value ?? ''" />
          @if (i === index && isClicked) {
          <span class="spinner-border spinner-border-sm ms-2" id="loading-spinner" role="status"></span>
          }
        </a>
      </li>
    </ng-container>
    }
  </ul>
</section>
